import Vue from 'vue'
import App from './App.vue'
import router from './router'
import moment from 'moment'
import moment_timezone from 'moment-timezone'

Vue.prototype.moment = moment
Vue.prototype.moment.tz = moment_timezone
Vue.prototype.$ENV = (window.location.hostname === 'localhost') ? 'LOCAL' : 'PRODUCTION'

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
